/* unplugin-vue-components disabled */import script from "./mg-history-route-tabs.vue?vue&type=script&lang=jsx&setup=true"
export * from "./mg-history-route-tabs.vue?vue&type=script&lang=jsx&setup=true"

import "./mg-history-route-tabs.vue?vue&type=style&index=0&id=28ac0ea2&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ac0ea2"]])

export default __exports__